import { useEffect, useState } from "react";
import { codigosRespuesta, IResponseApiFluent } from "../../../../../Interfaces/base/IResponse";
import { initialRazonModeloCommandCreate, IRazonModeloCommandCreate } from "../../../../../Interfaces/auxiliar/IRazonModelo";
import RazonModeloService from "../../../../../services/auxiliar/RazonModeloService";
import { IOpenPanel } from "../../../../../Interfaces/IPanel";

const UseNuevoRazonModelo = (props: IOpenPanel) => {
    const [disableForm, setDisableForm] = useState<boolean>(true);
    const [status, setStatus] = useState<codigosRespuesta>(0);
    const [mensaje, setMensaje] = useState<string>("");
    const [loading, setLoading] = useState<boolean>(false)
    const [command, setCommand] = useState<IRazonModeloCommandCreate>(initialRazonModeloCommandCreate)

    const required: (keyof IRazonModeloCommandCreate)[] = [
        "equipoModeloId",
        "razonId"
    ];

    const postInsertarRazonModelo = () => {
        setLoading(true)
        RazonModeloService.CrearRazonModelo(command)
            .then((res) => {
                if (res.status == 200) {
                    setStatus(200)
                    setMensaje(res.data.mensaje);
                    setTimeout(() => {
                        props.reload?.(command.razonId);
                        reset()
                    }, 3000)
                } else {
                    setStatus(500)
                }
                setLoading(false)
            })
            .catch((e) => {
                if (
                    e.response?.data &&
                    'type' in e.response.data &&
                    'title' in e.response.data &&
                    'status' in e.response.data &&
                    'instance' in e.response.data &&
                    'errors' in e.response.data
                ) {
                    const errorResponse = e.response.data as IResponseApiFluent;
                    const mensajeError = errorResponse.errors.join('\n');
                    setMensaje(mensajeError);
                } else {
                    setMensaje("Error Inesperado");
                }
                setStatus(500);
                setLoading(false);
            })
    }

    const reset = () => {
        setMensaje("")
        setCommand(initialRazonModeloCommandCreate)
        setStatus(0)
        props.onDismiss()
    }

    useEffect(() => {
        const check = required.every((field) => {
            const value = command[field];
            return value !== null && value !== undefined && value !== "";
        });
        setDisableForm(!check)
    }, [command])

    return { command, setCommand, postInsertarRazonModelo, loading, disableForm, reset, mensaje, status }
}

export { UseNuevoRazonModelo }